import { inject, Service } from '@angular/core';
import { Store } from '@ngrx/store';
import { departmentsActions } from '../actions/departments.actions';
import {
    selectDepartments,
    selectLoaded,
    selectLoading,
    selectLookup,
    selectLookupLoaded,
    selectLookupLoading,
    selectTotal,
} from '../selectors/departments.selector';
import { GetDepartmentsLookupValue, GetDepartmentsValue } from '../models';

@Service()
export class DepartmentsFacade {
    private readonly store = inject(Store);

    readonly departments = this.store.selectSignal(selectDepartments);
    readonly loaded = this.store.selectSignal(selectLoaded);
    readonly loading = this.store.selectSignal(selectLoading);
    readonly total = this.store.selectSignal(selectTotal);
    readonly lookupLoaded = this.store.selectSignal(selectLookupLoaded);
    readonly lookupLoading = this.store.selectSignal(selectLookupLoading);
    readonly lookup = this.store.selectSignal(selectLookup);

    getDepartments(value: GetDepartmentsValue): void {
        this.store.dispatch(departmentsActions.getDepartments({ value }));
    }

    getDepartmentsLookup(value: GetDepartmentsLookupValue): void {
        this.store.dispatch(departmentsActions.getDepartmentsLookup({ value }));
    }

    clear(): void {
        this.store.dispatch(departmentsActions.clear());
    }
}
